import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Logo from '../base/Logo';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Início', path: '/' },
    { name: 'Ativo Fixo', path: '/categoria/ativo-fixo-patrimonio' },
    { name: 'Estoques', path: '/categoria/controle-estoques-mro' },
    { name: 'Inventários', path: '/categoria/inventarios-auditorias' },
    { name: 'Tecnologia', path: '/categoria/tecnologia' },
    { name: 'Compliance', path: '/categoria/compliance-ifrs' }
  ];

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-[#CC0000] shadow-lg' : 'bg-[#CC0000]'}`}>
      {/* Top Bar */}
      <div className="bg-black">
        <div className="max-w-[1400px] mx-auto px-6 py-2">
          <div className="flex items-center justify-between text-white text-xs">
            <div className="flex items-center gap-6">
              <span className="flex items-center gap-2">
                <i className="ri-time-line"></i>
                {new Date().toLocaleDateString('pt-BR', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' })}
              </span>
            </div>
            <div className="flex items-center gap-4">
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="hover:text-[#CC0000] transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-sm"></i>
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="hover:text-[#CC0000] transition-colors cursor-pointer">
                <i className="ri-twitter-x-fill text-sm"></i>
              </a>
              <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="hover:text-[#CC0000] transition-colors cursor-pointer">
                <i className="ri-youtube-fill text-sm"></i>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Main Navigation */}
      <div className="bg-[#CC0000]">
        <div className="max-w-[1400px] mx-auto px-6">
          <div className="flex items-center justify-between h-16">
            {/* Logo */}
            <Link to="/" className="flex items-center cursor-pointer">
              <Logo variant="light" size="md" />
            </Link>

            {/* Desktop Navigation */}
            <div className="hidden lg:flex items-center gap-1">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`px-4 py-2 text-sm font-bold uppercase tracking-wide transition-colors cursor-pointer whitespace-nowrap ${
                    location.pathname === link.path
                      ? 'text-white bg-black/20'
                      : 'text-white/90 hover:text-white hover:bg-black/10'
                  }`}
                >
                  {link.name}
                </Link>
              ))}
            </div>

            {/* Right Actions */}
            <div className="hidden lg:flex items-center gap-3">
              <button className="w-9 h-9 flex items-center justify-center text-white hover:bg-black/20 rounded transition-colors cursor-pointer">
                <i className="ri-search-line text-lg"></i>
              </button>
              <button className="w-9 h-9 flex items-center justify-center text-white hover:bg-black/20 rounded transition-colors cursor-pointer">
                <i className="ri-user-line text-lg"></i>
              </button>
              <Link to="/contato">
                <button className="whitespace-nowrap cursor-pointer px-5 py-2 bg-black text-white text-sm font-bold uppercase hover:bg-black/80 transition-all">
                  Contato
                </button>
              </Link>
            </div>

            {/* Mobile Menu Button */}
            <button 
              className="lg:hidden w-10 h-10 flex items-center justify-center text-white cursor-pointer"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            >
              <i className={`text-2xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>

          {/* Mobile Menu */}
          {isMobileMenuOpen && (
            <div className="lg:hidden pb-4 border-t border-white/20">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`block py-3 text-sm font-bold uppercase transition-colors cursor-pointer ${
                    location.pathname === link.path
                      ? 'text-white'
                      : 'text-white/80'
                  }`}
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  {link.name}
                </Link>
              ))}
              <Link to="/contato" onClick={() => setIsMobileMenuOpen(false)}>
                <button className="w-full mt-4 px-5 py-2 bg-black text-white text-sm font-bold uppercase cursor-pointer">
                  Contato
                </button>
              </Link>
            </div>
          )}
        </div>
      </div>

      {/* Breaking News Ticker */}
      <div className="bg-black text-white">
        <div className="max-w-[1400px] mx-auto px-6 py-2">
          <div className="flex items-center gap-4">
            <span className="font-bold text-xs uppercase tracking-wide whitespace-nowrap flex items-center gap-2 text-[#CC0000]">
              <i className="ri-notification-3-fill"></i>
              Última Hora
            </span>
            <div className="overflow-hidden flex-1">
              <div className="flex gap-8 animate-marquee">
                <span className="text-xs whitespace-nowrap">Nova regulamentação IFRS impacta gestão de ativos fixos</span>
                <span className="text-xs whitespace-nowrap">•</span>
                <span className="text-xs whitespace-nowrap">Tecnologia RFID reduz perdas em 40%</span>
                <span className="text-xs whitespace-nowrap">•</span>
                <span className="text-xs whitespace-nowrap">Compliance: novas exigências para 2024</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
}
